// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3gvuE","inputWrap":"CustomTip_inputWrap__2PSoI"};